import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-36d48c46"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "install-statistics-export" }

import { useI18n } from 'vue-i18n'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import BtnIcon from '@/views/dashboard/_components/btn-icon/btn-icon.vue'
import { InstallStatisticsExportService } from './install-statistics-export.service'


export default /*#__PURE__*/_defineComponent({
  __name: 'install-statistics-export',
  props: {
    hasPermission: { type: Boolean, default: true }
  },
  setup(__props: any) {

const props = __props

const { t } = useI18n()
const injector = useReflectiveInjector([InstallStatisticsExportService])
const service = injector.get(InstallStatisticsExportService)

function handleExport () {
  if (!props.hasPermission) return
  Promise.all([
    service.downloadSoftwareViewStatistics(t('genuineSoftwareUsage.exportInstallStatSoftware')),
    service.downloadTerminalViewStatistics(t('genuineSoftwareUsage.exportInstallStatTerminal'))
  ])
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_button, {
      type: "primary",
      size: "small",
      plain: "",
      disabled: !_ctx.hasPermission,
      onClick: handleExport
    }, {
      default: _withCtx(() => [
        _createVNode(BtnIcon, { "icon-name": "export_h" }),
        _createTextVNode(" " + _toDisplayString(_ctx.$t('genuineSoftwareUsage.exportInstallStatistics')), 1)
      ]),
      _: 1
    }, 8, ["disabled"])
  ]))
}
}

})